import ReactMarkdown from 'react-markdown';
import { Button } from '../Utility/Button';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

function DSGVO() {
    const i18n = useSelector((state: any) => state.i18n.i18n);
    const settings = useSelector((state: any) => state.settings);
    const demo = useSelector((state: any) => state.settings.demo);
    const themes = useSelector((state: any) => state.themes.allThemes);
    const selectedTheme = useSelector((state: any) => state.themes.selectedTheme);
    const themeLogo = themes[selectedTheme].logo;

    const accept = () => {
        localStorage.setItem('acceptedDSGVO', 'true');
        document.location.reload();
    };

    useEffect(() => {
        if (settings.dataProtectionText === '' && !demo && localStorage.getItem('acceptedDSGVO') !== 'true') {
            localStorage.setItem('acceptedDSGVO', 'true');
            document.location.reload();
        }
    }, [demo, settings.dataProtectionText]);

    return settings.dataProtectionText ? (
        <>
            <div className="fixed inset-0 flex items-center justify-center z-[15]">
                <div
                    className={`${
                        demo ? 'demo-dashed-border' : ''
                    } p-8 bg-dsgvo-backgroundColor shadow-xl rounded-xl relative max-w-[850px] w-full`}
                >
                    {themeLogo && (
                        <div className="text-center mb-8">
                            <img src={themeLogo} alt="Logo" className="mx-auto h-8 w-auto" />
                        </div>
                    )}
                    <h5 className="m-0 mx-0 p-0 text-layout-textcolor text-center">
                        {i18n.translate({
                            id: 'welcome',
                            sourceName: 'DSGVO',
                        })}
                    </h5>
                    {demo && (
                        <h3 className="m-0 mx-0 p-0 text-primary text-center">
                            {i18n.translate({
                                id: 'demo',
                                sourceName: 'DSGVO',
                            })}
                        </h3>
                    )}
                    <div className="max-h-[200px] overflow-y-auto rounded-xl bg-dsgvo-boxBackgroundColor my-8 p-3">
                        <ReactMarkdown className="my-3 mx-5 text-layout-textcolor">
                            {settings.dataProtectionText}
                        </ReactMarkdown>
                    </div>
                    <div className="flex justify-end items-center mx-0">
                        <Button onClick={accept}>{i18n.translate({ id: 'accept', sourceName: 'DSGVO' })}</Button>

                        {demo && (
                            <div className="space-x-2 hidden md:flex">
                                <Button onClick={() => (document.location.href = 'https://www.varios-ai.com')}>
                                    {i18n.translate({
                                        id: 'website',
                                        sourceName: 'DSGVO',
                                    })}
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <img
                className="w-full h-full object-cover z-0 fixed left-0 top-0"
                src="/img/background_varios.jpg"
                alt=""
            />
        </>
    ) : (
        <div></div>
    );
}

export default DSGVO;
